// extracted by mini-css-extract-plugin
module.exports = {"mod-list":"UnOrderedList_mod-list__Czdd4","list":"UnOrderedList_list__2dmMV"};